import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./addon-fees.css";

export default function AddonFeeAdd() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin")).school;

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [form, setForm] = useState({
    class_id: "",
    section_id: "",
    student_ids: [],
    title: "",
    amount: "",
  });

  /* ================= LOAD CLASSES ================= */
  useEffect(() => {
    API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.id },
    }).then((res) => setClasses(res.data.classes || []));
  }, []);

  /* ================= LOAD SECTIONS ================= */
  useEffect(() => {
    if (!form.class_id) {
      setSections([]);
      setStudents([]);
      return;
    }

    API.get(`/school-admin/sections/?class_id=${form.class_id}`, {
      headers: { "X-SCHOOL-ID": school.id },
    }).then((res) => setSections(res.data.sections || []));
  }, [form.class_id]);

  /* ================= LOAD STUDENTS ================= */
  useEffect(() => {
    if (!form.class_id || !form.section_id) {
      setStudents([]);
      return;
    }

    API.get(
      `/school-admin/students/?class_id=${form.class_id}&section_id=${form.section_id}`,
      { headers: { "X-SCHOOL-ID": school.id } }
    ).then((res) => {
      setStudents(res.data.students || []);
      setForm((prev) => ({ ...prev, student_ids: [] }));
      setSelectAll(false);
    });
  }, [form.class_id, form.section_id]);

  /* ================= HANDLE INPUT ================= */
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  /* ================= SELECT ALL ================= */
  const handleSelectAll = () => {
    if (selectAll) {
      setForm({ ...form, student_ids: [] });
    } else {
      setForm({
        ...form,
        student_ids: students.map((s) => s.id),
      });
    }
    setSelectAll(!selectAll);
  };

  /* ================= TOGGLE STUDENT ================= */
  const toggleStudent = (id) => {
    setForm((prev) => {
      const updated = prev.student_ids.includes(id)
        ? prev.student_ids.filter((x) => x !== id)
        : [...prev.student_ids, id];

      setSelectAll(updated.length === students.length);

      return {
        ...prev,
        student_ids: updated,
      };
    });
  };

  /* ================= SAVE ================= */
  const saveAddon = async () => {
    if (!form.student_ids.length || !form.title || !form.amount) {
      alert("Select students, title and amount");
      return;
    }

    const payload = {
      student_ids: form.student_ids.map((id) => Number(id)),
      class_id: Number(form.class_id),
      section_id: Number(form.section_id),
      title: form.title.trim(),
      amount: Number(form.amount),
    };

    await API.post("/school-admin/addon-fees/add/", payload, {
      headers: { "X-SCHOOL-ID": school.id },
    });

    alert(`Fee added for ${payload.student_ids.length} students ✅`);

    setForm({
      ...form,
      student_ids: [],
      title: "",
      amount: "",
    });

    setSelectAll(false);
  };

  return (
    <div className="addon-page">
      <h2 className="addon-title">Add Fee</h2>

      <div className="addon-form">

        {/* CLASS */}
        <div className="form-group">
          <label>Class</label>
          <select name="class_id" value={form.class_id} onChange={handleChange}>
            <option value="">Select Class</option>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        {/* SECTION */}
        <div className="form-group">
          <label>Section</label>
          <select
            name="section_id"
            value={form.section_id}
            onChange={handleChange}
            disabled={!sections.length}
          >
            <option value="">Select Section</option>
            {sections.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        {/* STUDENTS */}
        <div className="form-group">
          <div className="student-header">
            <label>Students</label>

            {students.length > 0 && (
              <label className="select-all">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                Select All
              </label>
            )}
          </div>

          {students.length > 0 && (
            <p className="count">
              {form.student_ids.length} selected / {students.length}
            </p>
          )}

          <div className="student-checkbox-list">
            {students.length === 0 ? (
              <p className="muted">Select class & section first</p>
            ) : (
              students.map((s) => (
                <label key={s.id} className="student-checkbox">
                  <input
                    type="checkbox"
                    checked={form.student_ids.includes(s.id)}
                    onChange={() => toggleStudent(s.id)}
                  />
                  {s.name}
                </label>
              ))
            )}
          </div>
        </div>

        {/* TITLE */}
        <div className="form-group">
          <label>Fee Type</label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="e.g. School Fee (Annual), Transport Fee"
          />
        </div>

        {/* AMOUNT */}
        <div className="form-group">
          <label>Amount (₹)</label>
          <input
            name="amount"
            type="number"
            value={form.amount}
            onChange={handleChange}
            placeholder="Enter amount"
          />
        </div>

        {/* SAVE */}
        <button className="btn-submit" onClick={saveAddon}>
          Save Fee
        </button>
      </div>
    </div>
  );
}